module.exports = __webpack_public_path__ + "img/smartcard.7e0ac222.png";